var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResourceAugmentation3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2756.09 2757.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#91b3fa;}.cls-4{fill:#bdd0fb;}.cls-10,.cls-11,.cls-33,.cls-5{fill:#fff;}.cls-5{mix-blend-mode:soft-light;}.cls-6{fill:#18174a;}.cls-7{fill:#2b69b3;}.cls-8{fill:#7d97f4;}.cls-9{opacity:0.56;}.cls-10{opacity:0.53;}.cls-11{opacity:0.35;}.cls-12{fill:url(#linear-gradient-2);}.cls-13{fill:url(#linear-gradient-3);}.cls-14{fill:url(#linear-gradient-4);}.cls-15{fill:url(#linear-gradient-5);}.cls-16{fill:url(#linear-gradient-6);}.cls-17{fill:url(#linear-gradient-7);}.cls-18{fill:url(#linear-gradient-8);}.cls-19{fill:url(#linear-gradient-9);}.cls-20{fill:url(#linear-gradient-10);}.cls-21{fill:url(#linear-gradient-11);}.cls-22{fill:url(#linear-gradient-12);}.cls-23{fill:url(#linear-gradient-13);}.cls-24{fill:url(#linear-gradient-14);}.cls-25{fill:url(#linear-gradient-15);}.cls-26{fill:url(#linear-gradient-16);}.cls-27{fill:url(#linear-gradient-17);}.cls-28{fill:url(#linear-gradient-18);}.cls-29{fill:url(#linear-gradient-19);}.cls-30{fill:url(#linear-gradient-20);}.cls-31{fill:url(#linear-gradient-21);}.cls-32{fill:url(#linear-gradient-22);}.cls-34{fill:url(#linear-gradient-23);}.cls-35{fill:url(#linear-gradient-24);}.cls-36{fill:url(#linear-gradient-25);}.cls-37{fill:url(#linear-gradient-26);}.cls-38{fill:url(#linear-gradient-27);}.cls-39{fill:url(#linear-gradient-28);}.cls-40{fill:url(#linear-gradient-29);}.cls-41{fill:url(#linear-gradient-30);}.cls-42{fill:url(#linear-gradient-31);}.cls-43{fill:url(#linear-gradient-32);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3099.54,
    y1: 3551.89,
    x2: 662.4,
    y2: 525.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -821.02,
    y1: 2616.3,
    x2: -833.86,
    y2: 2515.85,
    gradientTransform: "matrix(-1, 0, 0, 1, 1188.9, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1101.82,
    y1: 2650.72,
    x2: -1114.34,
    y2: 2552.84,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1109.38,
    y1: 2219.67,
    x2: -1095.36,
    y2: 2191.64,
    gradientTransform: "matrix(-1, 0, 0, 1, 1188.9, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2499.76,
    y1: 1295.84,
    x2: 2407.09,
    y2: 1448.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2235.93,
    y1: 1534.34,
    x2: 2173.05,
    y2: 1607.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -1007.19,
    y1: 2007.86,
    x2: -831.73,
    y2: 2007.86,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -845.5,
    y1: 1787.9,
    x2: -517.82,
    y2: 1787.9,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -963.47,
    y1: 1604.12,
    x2: -849.43,
    y2: 1487.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -798.08,
    y1: 1413.4,
    x2: -940.26,
    y2: 1601.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -1006.32,
    y1: 1562.35,
    x2: -892.28,
    y2: 1445.35,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2356.35,
    y1: 1495.99,
    x2: 2296.79,
    y2: 1600.24,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1900.01,
    y1: 2091.19,
    x2: 1425.28,
    y2: 2495.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1620.43,
    y1: 2408.11,
    x2: 1966.05,
    y2: 2606.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -217.58,
    y1: 1865.6,
    x2: -17.24,
    y2: 2301.63,
    gradientTransform: "matrix(-1, 0, 0, 1, 1188.9, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -212.75,
    y1: 1894.56,
    x2: -231.61,
    y2: 1773.55,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -294.26,
    y1: 1666.51,
    x2: -127.68,
    y2: 1779.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -307.03,
    y1: 1644.78,
    x2: -114.14,
    y2: 1775.8,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -104.49,
    y1: 2104.08,
    x2: 249.68,
    y2: 2104.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 2070.96,
    y1: 1660.64,
    x2: 2053.38,
    y2: 1878.19,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -519.45,
    y1: 1077.86,
    x2: -376.45,
    y2: 1403.22,
    gradientTransform: "matrix(-1, 0, 0, 1, 48.14, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -557.91,
    y1: 1067.08,
    x2: -459.14,
    y2: 1291.8,
    gradientTransform: "matrix(-1, 0, 0, 1, 48.14, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -76.8,
    y1: 2208.75,
    x2: -11.17,
    y2: 2208.75,
    gradientTransform: "matrix(-1, 0, 0, 1, 48.14, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -354.15,
    y1: 2467.58,
    x2: -259.69,
    y2: 1363.65,
    gradientTransform: "matrix(-1, 0, 0, 1, 48.14, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -381.74,
    y1: 2196.77,
    x2: -275.53,
    y2: 2196.77,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -164.15,
    y1: 2484.01,
    x2: -69.67,
    y2: 1379.79,
    gradientTransform: "matrix(-1, 0, 0, 1, 48.14, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 939.94,
    y1: 1099.41,
    x2: 767.85,
    y2: 1192.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -364.5,
    y1: 1379.44,
    x2: -346.76,
    y2: 1249.63,
    gradientTransform: "matrix(-1, 0, 0, 1, 48.14, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -409.29,
    y1: 1212.08,
    x2: -254.48,
    y2: 936.58,
    gradientTransform: "matrix(-1, 0, 0, 1, 48.14, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -376.33,
    y1: 1230.6,
    x2: -221.53,
    y2: 955.09,
    gradientTransform: "matrix(-1, 0, 0, 1, 48.14, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 6128.06,
    y1: 3855.18,
    x2: 6352.85,
    y2: 3855.18,
    gradientTransform: "matrix(0.45, 0.89, 0.89, -0.45, -5739.04, -2529.61)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 2004.33,
    y1: 824.86,
    x2: 1474.83,
    y2: 2221.41,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-15"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2436.59,2353c-56.39,58.65-109.75,96.47-151.91,126.35-495.55,351.26-1081.92,248.87-1206.54,223.87-184-36.93-539.74-108.3-796.91-407.07-389.09-452-328.5-1164.15-26.7-1634.24,55.2-86,346.81-563.24,939.49-639.78,358.69-46.32,776.8,47.1,1079.59,297.71C2909.18,845.88,2863.94,1908.57,2436.59,2353Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1633,229.64a3.45,3.45,0,0,1-2.23-.19,3.53,3.53,0,0,1-1.83-4.65c1.89-4.35,3.89-8.71,5.94-13a3.54,3.54,0,0,1,6.37,3.07c-2,4.17-4,8.45-5.83,12.71A3.52,3.52,0,0,1,1633,229.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2310.29,222a3.54,3.54,0,0,1-4-2c-4-8.67-8.41-17.28-13.09-25.61a3.53,3.53,0,0,1,6.16-3.46c4.77,8.49,9.26,17.27,13.35,26.11a3.55,3.55,0,0,1-1.73,4.69A4,4,0,0,1,2310.29,222Zm-38.9-65.42a3.53,3.53,0,0,1-3.66-1.32c-5.69-7.64-11.77-15.17-18.07-22.38a3.54,3.54,0,1,1,5.32-4.66c6.42,7.35,12.62,15,18.42,22.82a3.53,3.53,0,0,1-2,5.54Zm-51.45-56.1a3.53,3.53,0,0,1-3.18-.79c-7.15-6.37-14.62-12.52-22.21-18.28a3.54,3.54,0,0,1,4.28-5.63c7.73,5.88,15.35,12.15,22.63,18.63a3.53,3.53,0,0,1,.29,5A3.48,3.48,0,0,1,2219.94,100.5Zm-557.87,75.22a3.53,3.53,0,0,1-3.78-5.36c5.3-8.15,11-16.19,16.94-23.92a3.53,3.53,0,0,1,5.6,4.3c-5.83,7.58-11.42,15.48-16.62,23.47A3.57,3.57,0,0,1,1662.07,175.72ZM2158.23,56a3.54,3.54,0,0,1-2.59-.37c-8.27-4.76-16.83-9.25-25.46-13.34a3.53,3.53,0,0,1,3-6.38c8.79,4.17,17.52,8.74,25.95,13.59a3.54,3.54,0,0,1-.93,6.5Zm-448.31,60.53a3.53,3.53,0,0,1-3.34-5.92c6.88-6.93,14.09-13.66,21.43-20a3.53,3.53,0,1,1,4.62,5.34c-7.21,6.23-14.29,12.83-21,19.63A3.47,3.47,0,0,1,1709.92,116.51Zm378.79-91.45a3.5,3.5,0,0,1-1.92-.07c-9-2.95-18.35-5.59-27.66-7.84a3.53,3.53,0,0,1,1.66-6.87c9.49,2.29,19,5,28.2,8a3.55,3.55,0,0,1,2.26,4.46A3.51,3.51,0,0,1,2088.71,25.06Zm-320,43.14a3.54,3.54,0,0,1-2.78-6.39c8.12-5.37,16.56-10.49,25.07-15.2a3.53,3.53,0,1,1,3.42,6.18c-8.35,4.62-16.62,9.64-24.59,14.91A3.51,3.51,0,0,1,1768.74,68.2ZM2014.33,9a3.25,3.25,0,0,1-1.21.08c-9.49-1-19.14-1.73-28.69-2a3.53,3.53,0,1,1,.23-7.06c9.73.31,19.57,1,29.23,2.08a3.53,3.53,0,0,1,.44,6.94Zm-76.09-.59a4,4,0,0,1-.5.09c-9.49.89-19.08,2.18-28.51,3.82a3.53,3.53,0,0,1-4.08-2.88A3.59,3.59,0,0,1,1908,5.38c9.61-1.67,19.38-3,29.06-3.9a3.53,3.53,0,0,1,1.16,7ZM1836.2,33a3.53,3.53,0,0,1-2.13-6.72c9-3.59,18.35-6.87,27.65-9.74a3.53,3.53,0,0,1,2.09,6.75c-9.13,2.82-18.25,6-27.13,9.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2331.34,279.7a3.54,3.54,0,0,1-4.23-2.51c-1.22-4.47-2.55-9-3.94-13.41a3.52,3.52,0,0,1,2.31-4.43,3.58,3.58,0,0,1,4.43,2.31c1.42,4.51,2.77,9.12,4,13.67a3.54,3.54,0,0,1-2.48,4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2293,566.69a3.48,3.48,0,0,1-2.62-.39,3.53,3.53,0,0,1-1.24-4.84c2.38-4,4.7-8.12,6.89-12.18a3.53,3.53,0,0,1,6.21,3.37c-2.23,4.13-4.6,8.31-7,12.41A3.53,3.53,0,0,1,2293,566.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2060.65,738.69l-3.11.73a3.53,3.53,0,0,1-1.62-6.87h0l3.05-.72c8.11-2,16.27-4.22,24.25-6.73a3.56,3.56,0,0,1,4.43,2.31,3.52,3.52,0,0,1-2.3,4.43C2077.24,734.39,2068.92,736.7,2060.65,738.69Zm-48.84,8.37a3.85,3.85,0,0,1-.47.08c-9.52,1-19.2,1.61-28.78,1.87a3.53,3.53,0,1,1-.19-7.06c9.4-.25,18.9-.87,28.24-1.84a3.53,3.53,0,0,1,1.2,6.95Zm116.64-31.85a3.53,3.53,0,0,1-2.3-6.64c8.55-3.93,17-8.24,25.24-12.8a3.53,3.53,0,1,1,3.43,6.16c-8.35,4.66-17,9.05-25.72,13.06A4.15,4.15,0,0,1,2128.45,715.21Zm-191.54,32.06a3.49,3.49,0,0,1-1.17.08c-9.55-.94-19.16-2.25-28.57-3.91a3.53,3.53,0,0,1,1.23-7c9.23,1.63,18.66,2.92,28,3.84a3.53,3.53,0,0,1,.48,6.95ZM2193,677.18a3.53,3.53,0,0,1-2.92-6.28c7.54-5.54,15-11.47,22.13-17.63a3.53,3.53,0,1,1,4.62,5.35c-7.29,6.28-14.88,12.33-22.57,18A3.37,3.37,0,0,1,2193,677.18ZM1863.5,732.5a3.47,3.47,0,0,1-1.86-.07c-9.14-2.82-18.29-6-27.2-9.57a3.53,3.53,0,1,1,2.6-6.56c8.74,3.45,17.72,6.61,26.68,9.39a3.53,3.53,0,0,1-.22,6.81ZM2248.56,627a3.53,3.53,0,0,1-3.45-5.8c6.31-7,12.43-14.27,18.19-21.69a3.53,3.53,0,1,1,5.58,4.34c-5.87,7.56-12.11,15-18.54,22.09A3.47,3.47,0,0,1,2248.56,627Zm-454,76.29a3.5,3.5,0,0,1-2.52-.34c-8.37-4.61-16.68-9.61-24.71-14.88a3.53,3.53,0,1,1,3.87-5.9c7.88,5.16,16,10.07,24.24,14.59a3.53,3.53,0,0,1-.88,6.53ZM1733,660.68a3.5,3.5,0,0,1-3.12-.75c-5.73-4.88-11.41-10-16.86-15.26-1.48-1.41-2.93-2.83-4.37-4.26a3.53,3.53,0,0,1,5-5c1.42,1.41,2.85,2.8,4.29,4.19,5.36,5.15,10.93,10.19,16.55,15a3.53,3.53,0,0,1-1.46,6.12Zm-51.9-54a3.55,3.55,0,0,1-3.61-1.25c-5.91-7.54-11.6-15.4-16.92-23.37a3.53,3.53,0,0,1,5.88-3.92c5.21,7.82,10.8,15.53,16.6,22.92a3.54,3.54,0,0,1-.6,5A3.47,3.47,0,0,1,1681.08,606.68Zm-40-63.31a3.52,3.52,0,0,1-4-1.86c-4.27-8.56-8.25-17.42-11.85-26.3a3.53,3.53,0,1,1,6.55-2.65c3.53,8.72,7.44,17.4,11.62,25.8a3.53,3.53,0,0,1-1.59,4.74A3.36,3.36,0,0,1,1641.05,543.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1614.61,473.15a3.53,3.53,0,0,1-4.24-2.53c-1.2-4.55-2.34-9.21-3.38-13.85a3.68,3.68,0,0,1,2.67-4.22,3.52,3.52,0,0,1,4.22,2.67c1,4.56,2.14,9.13,3.32,13.59a3.53,3.53,0,0,1-2.51,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1688.73,401.53a4.45,4.45,0,0,0,3,4.25l51,18.28a235.92,235.92,0,0,0,28.42,71l-24.3,48.42a4.44,4.44,0,0,0,.79,5.11l45.44,46.53a4.46,4.46,0,0,0,5.09.91l49-23.15A236,236,0,0,0,1917.49,603l17.07,51.46a4.45,4.45,0,0,0,4.17,3l65,.77a4.47,4.47,0,0,0,4.25-2.95l18.27-51.05a236.08,236.08,0,0,0,71-28.42l48.42,24.31a4.46,4.46,0,0,0,5.11-.8L2197.38,554a4.46,4.46,0,0,0,.92-5.09l-23.15-49a236.54,236.54,0,0,0,30.09-70.35l51.46-17.07a4.44,4.44,0,0,0,3.05-4.17l.77-65a4.46,4.46,0,0,0-3-4.24l-51-18.28a235.92,235.92,0,0,0-28.42-71l24.31-48.43a4.46,4.46,0,0,0-.8-5.11l-45.44-46.52a4.46,4.46,0,0,0-5.09-.92l-49,23.16a236,236,0,0,0-70.35-30.09l-17.07-51.46a4.43,4.43,0,0,0-4.17-3l-65-.77a4.45,4.45,0,0,0-4.25,3l-18.27,51a236.18,236.18,0,0,0-71,28.42l-48.43-24.3a4.44,4.44,0,0,0-5.11.79l-46.52,45.44a4.46,4.46,0,0,0-.92,5.09l23.15,49A236.54,236.54,0,0,0,1744,315.26l-51.45,17.07a4.47,4.47,0,0,0-3.06,4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1989.39,433.68l-.06,0a79.86,79.86,0,1,1,.06,0Zm-27.05-112.27a52.44,52.44,0,0,0,24.52,102h.05a52.45,52.45,0,0,0-24.52-102Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2014.25,529.9a162.36,162.36,0,0,1-175.69-71.38l9-5.64a152.7,152.7,0,0,0,20,25.35c45.89,47,115.1,57.78,171.66,31.9l.31-.14c.11-.06.22-.1.33-.15a151.71,151.71,0,0,0,87.78-135.75,152.8,152.8,0,0,0-4.22-37.61,150.66,150.66,0,0,0-38.92-70.12c-58.41-59.81-154.6-61-214.41-2.54a151.49,151.49,0,0,0-40.68,69.77l-10.25-2.7a162.06,162.06,0,0,1,43.53-74.65c64-62.49,166.89-61.28,229.39,2.71a162.16,162.16,0,0,1-77.8,271Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2270.88,328.22a4,4,0,0,1-2.55-.23,4,4,0,0,1-2.09-5.3c2.17-5,4.54-10,7-14.81a4,4,0,0,1,7.17,3.7c-2.41,4.67-4.7,9.5-6.8,14.33A4.06,4.06,0,0,1,2270.88,328.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2715.66,297a4.06,4.06,0,0,1-4.38-1.81,247.06,247.06,0,0,0-19.27-27,4,4,0,1,1,6.24-5.12,256.35,256.35,0,0,1,19.9,27.93,4,4,0,0,1-1.32,5.55A4.1,4.1,0,0,1,2715.66,297ZM2657,231.14a4,4,0,0,1-3.45-.76,247.91,247.91,0,0,0-27.38-18.77,4,4,0,0,1,4.1-7,255.89,255.89,0,0,1,28.28,19.39,4,4,0,0,1,.67,5.67A4.09,4.09,0,0,1,2657,231.14ZM2308.06,268a4,4,0,0,1-4-6.5c3.89-4.67,8-9.28,12.26-13.7,3.67-3.83,7.5-7.58,11.38-11.14a4,4,0,1,1,5.46,5.93c-3.76,3.46-7.46,7.09-11,10.79-4.12,4.29-8.12,8.76-11.88,13.28A4.08,4.08,0,0,1,2308.06,268Zm271.18-78.44a4.05,4.05,0,0,1-2.18-.08,247.49,247.49,0,0,0-32.2-8.11,4,4,0,1,1,1.44-7.94,258,258,0,0,1,33.25,8.37,4,4,0,0,1-.31,7.76ZM2375.42,211a4,4,0,0,1-3-7.41,255.18,255.18,0,0,1,30.77-15.15,4,4,0,0,1,3.07,7.46,247.12,247.12,0,0,0-29.79,14.67A4.13,4.13,0,0,1,2375.42,211Zm116.48-33.6a4.17,4.17,0,0,1-.8.11,250.26,250.26,0,0,0-33,3.47,4,4,0,0,1-4.66-3.29,4.12,4.12,0,0,1,3.29-4.66,257.86,257.86,0,0,1,34.09-3.58,4,4,0,0,1,1.11,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2743.9,362.13a4,4,0,0,1-4.84-2.86c-1.39-5.09-3-10.19-4.67-15.16a4,4,0,0,1,2.5-5.13,4,4,0,0,1,5.13,2.5c1.76,5.14,3.39,10.41,4.82,15.66a4,4,0,0,1-2.82,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2714.52,562.13a4,4,0,0,1-4.36-6.07c2.8-4.46,5.49-9.08,8-13.7a4,4,0,0,1,7.1,3.84c-2.59,4.78-5.37,9.54-8.26,14.15A4.07,4.07,0,0,1,2714.52,562.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2579.91,667.53a4,4,0,0,1-2.19-7.76,244.73,244.73,0,0,0,30.29-12.2,4,4,0,1,1,3.51,7.27,255.73,255.73,0,0,1-31.3,12.6Zm-52.69,11.19a3.41,3.41,0,0,1-.54.1,258.15,258.15,0,0,1-33.71,1.23,4,4,0,0,1,.24-8.06,248.79,248.79,0,0,0,32.64-1.2,4,4,0,0,1,1.37,7.93Zm129.21-52.1a4,4,0,0,1-3.44-7.1,248.57,248.57,0,0,0,24.32-21.82,4,4,0,0,1,5.77,5.64A257.39,257.39,0,0,1,2658,625.87,4,4,0,0,1,2656.43,626.62Zm-215.77,46a4,4,0,0,1-1.91,0,256.6,256.6,0,0,1-32.13-10.27,4,4,0,0,1,3-7.51,245.8,245.8,0,0,0,31.11,9.94,4,4,0,0,1,0,7.84Zm-79.3-35.17a4,4,0,0,1-3.2-.58,257.91,257.91,0,0,1-26.68-20.62,4,4,0,0,1,5.34-6,250.43,250.43,0,0,0,25.84,20,4,4,0,0,1-1.3,7.27Zm-62.64-60.05a4,4,0,0,1-4.2-1.53,253.9,253.9,0,0,1-18.14-28.44,4,4,0,0,1,7.07-3.88A247.76,247.76,0,0,0,2301,571.11a4,4,0,0,1-.86,5.64A3.94,3.94,0,0,1,2298.72,577.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2260.16,499.48a4,4,0,0,1-4.81-2.79c-1.53-5.22-2.91-10.56-4.1-15.86a4,4,0,0,1,3-4.8l.07,0a4,4,0,0,1,4.82,3.06c1.15,5.13,2.48,10.3,4,15.36a4,4,0,0,1-2.74,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2308.22,443.06a3,3,0,0,0,2,2.87l34.57,12.38A160.34,160.34,0,0,0,2364,506.44l-16.46,32.8a3,3,0,0,0,.54,3.46l30.78,31.51a3,3,0,0,0,3.45.62l33.18-15.68a160,160,0,0,0,47.65,20.38l11.56,34.86a3,3,0,0,0,2.83,2.06l44,.53a3,3,0,0,0,2.87-2l12.38-34.58A159.66,159.66,0,0,0,2585,561.15l32.81,16.46a3,3,0,0,0,3.46-.53l31.51-30.78a3,3,0,0,0,.62-3.45l-15.68-33.18A160,160,0,0,0,2658.09,462L2693,450.45a3,3,0,0,0,2.06-2.82l.52-44.05a3,3,0,0,0-2-2.88L2659,388.32a159.87,159.87,0,0,0-19.25-48.12l16.46-32.8a3,3,0,0,0-.53-3.46l-30.78-31.52a3,3,0,0,0-3.45-.62l-33.18,15.69a159.77,159.77,0,0,0-47.66-20.38L2529,232.25a3,3,0,0,0-2.82-2.07l-44.05-.52a3,3,0,0,0-2.88,2l-12.38,34.57a160.15,160.15,0,0,0-48.12,19.26L2386,269a3,3,0,0,0-3.46.54L2351,300.34a3,3,0,0,0-.62,3.45L2366.05,337a159.72,159.72,0,0,0-20.38,47.65l-34.86,11.56a3,3,0,0,0-2.07,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2512.46,467.23h-.05a41.33,41.33,0,1,1,.05,0Zm-18.32-76a33.06,33.06,0,0,0,15.45,64.28h0a33.05,33.05,0,1,0-15.48-64.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2529.3,532.4a112.37,112.37,0,0,1-120.19-47.15c-.51-.75-1-1.51-1.48-2.28l10.25-6.44a100.82,100.82,0,0,0,13.22,16.76h0a99.56,99.56,0,0,0,18,14.63l.06,0,.09.06a100.59,100.59,0,0,0,95.07,6.47,99.07,99.07,0,0,0,22.33-14l.67-.55.53-.46,1.36-1.18q1.85-1.62,3.61-3.36a99.56,99.56,0,0,0,30.2-70.52,100.8,100.8,0,0,0-2.79-24.86,100.28,100.28,0,0,0-194.38-1.92l-11.71-3.08A112.37,112.37,0,1,1,2529.3,532.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.31,19.63C31.35,7,49.09-1.37,60,7.44,170.29,96.91,435.39,364.83,369.32,833c-82.89,587.44,58.83,801.8,235.22,932.55,0,0-242.25-61.49-394.67-279C-164.34,952.56,87,243.9,34.31,19.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M118.28,203.11c13.8,65.39,26.1,131,35.61,196.88q14.85,98.76,22.69,198.08c4.9,66.19,8.36,132.45,8.56,198.73.54,66.28-2.22,132.51-5.25,199-2.61,66.46-5.67,133.4-.8,200.82s18.94,135.14,47,198.76c7,15.85,14.42,31.66,22.81,46.93,8.07,15.42,16.93,30.53,26.1,45.49a718.64,718.64,0,0,0,62.58,86.1c46.63,54.67,102.86,103.17,164.8,144.22,6.52,4.32,15.86,3.26,20.86-2.37s3.82-13.41-2.4-17.78l0,0c-14.74-10.36-29.32-20.84-43.31-31.85-7.1-5.41-13.91-11.08-20.84-16.64-6.67-5.77-13.61-11.33-20.07-17.28a713.51,713.51,0,0,1-72.78-74.8c-44.47-52.57-80.07-111.16-107-171.89a582.18,582.18,0,0,1-31.2-93.67,640.11,640.11,0,0,1-15-97c-5.3-65.43-2.9-131.71-.85-198.18s3.38-133.32,1.63-200.09q-1.17-50.09-4.4-100.09c-1-16.67-2.31-33.32-3.62-50q-2.24-25-4.85-49.88Q187.72,496.9,169.88,398C157.6,332.18,143.3,266.66,126.1,201.72a4,4,0,0,0-4.79-2.59A3.5,3.5,0,0,0,118.28,203.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M300.27,1352.91c-13.53,14.36-37.32,10.23-45.46-7.74-44.9-99.13-146.52-390.91,21.31-727.05,141.71-283.85,191.58-451.24,209-528.79,3.67-16.4,26.15-18.58,32.93-3.2C592.85,255.77,790.48,832.81,300.27,1352.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M275.7,1342.45a7.31,7.31,0,0,1-1.49.12,7.7,7.7,0,0,1-7.58-7.82c.08-4.82,9.46-486.68,188.68-890.26a7.7,7.7,0,1,1,14.08,6.25C291.47,851.38,282.11,1330.2,282,1335A7.69,7.69,0,0,1,275.7,1342.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1193.85 1828.38 1136.97 2338.49 1796.86 2338.49 1710.91 1828.38 1193.85 1828.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.58,535.11V1737.29a182.37,182.37,0,0,0,177.67,182.32c439.1,11.32,1974.84,38.78,2392.83,32.61a134.19,134.19,0,0,0,132.12-130.36c8.06-279.29,21.15-950.87-27.3-1262.66a138.08,138.08,0,0,0-132-116.88C2221,430.55,593,393.17,175.17,402.56A132.55,132.55,0,0,0,45.58,535.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M121,529.25V1671.41A105.66,105.66,0,0,0,225.1,1777.06L2556,1805.86a102.82,102.82,0,0,0,104.37-102.44l3.9-1131.95A75.22,75.22,0,0,0,2590.84,496L204.48,447.79A81.48,81.48,0,0,0,121,529.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2677.87,1853.19h0L121,1809.62a3.75,3.75,0,0,1,.13-7.49l2556.85,43.56a3.75,3.75,0,0,1-.06,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1939,2442.86H973.21c-26.24,0-46-18.68-40.87-38.74l12.39-49c3.73-14.74,19.94-25.56,39.2-26.16L1915,2299.89c20.13-.63,37.94,10.05,42.33,25.37l22.34,78.06C1985.46,2423.61,1965.66,2442.86,1939,2442.86Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1344.85,737.05l-224.69-1.46a7.75,7.75,0,0,1-7.79-7.71l.23-30.26a7.75,7.75,0,0,1,7.9-7.59l224.69,1.46a7.75,7.75,0,0,1,7.79,7.71l-.23,30.26A7.75,7.75,0,0,1,1344.85,737.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1864.52,740.43l-449.81-2.93a12.31,12.31,0,0,1-12.39-12.25l.16-21.23A12.32,12.32,0,0,1,1415,692l449.8,2.92a12.3,12.3,0,0,1,12.39,12.25l-.16,21.24A12.33,12.33,0,0,1,1864.52,740.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1346.18,817.21l-224.69-1.46a7.74,7.74,0,0,1-7.79-7.71l.22-30.26a7.76,7.76,0,0,1,7.9-7.59l224.69,1.46a7.75,7.75,0,0,1,7.8,7.71l-.23,30.26A7.75,7.75,0,0,1,1346.18,817.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2252.59,823.1l-670.53-4.36a12.31,12.31,0,0,1-12.39-12.25l.16-21.24a12.33,12.33,0,0,1,12.56-12.07l670.53,4.36a12.32,12.32,0,0,1,12.39,12.25l-.16,21.24A12.33,12.33,0,0,1,2252.59,823.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1345.4,897.24l-224.69-1.46a7.74,7.74,0,0,1-7.79-7.71l.22-30.26a7.76,7.76,0,0,1,7.9-7.59l224.69,1.46a7.75,7.75,0,0,1,7.8,7.7l-.23,30.26A7.76,7.76,0,0,1,1345.4,897.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2547.88,905.05l-881.32-5.73a12.31,12.31,0,0,1-12.39-12.25l.16-21.23a12.32,12.32,0,0,1,12.56-12.07l881.31,5.72a12.32,12.32,0,0,1,12.39,12.25l-.16,21.24A12.32,12.32,0,0,1,2547.88,905.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1346.73,977.39,1122,975.93a7.74,7.74,0,0,1-7.8-7.7l.23-30.26a7.75,7.75,0,0,1,7.9-7.59l224.69,1.46a7.74,7.74,0,0,1,7.79,7.7l-.22,30.26A7.76,7.76,0,0,1,1346.73,977.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2552,985.23l-881.31-5.73a12.31,12.31,0,0,1-12.39-12.25l.16-21.24a12.33,12.33,0,0,1,12.56-12.07l881.31,5.73a12.32,12.32,0,0,1,12.39,12.25l-.16,21.24A12.33,12.33,0,0,1,2552,985.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1345.37,1060.55l-224.69-1.46a7.74,7.74,0,0,1-7.79-7.7l.22-30.26a7.77,7.77,0,0,1,7.9-7.6L1345.7,1015a7.74,7.74,0,0,1,7.8,7.7l-.23,30.26A7.75,7.75,0,0,1,1345.37,1060.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2549.61,1068.38l-881.31-5.73a12.31,12.31,0,0,1-12.39-12.25l.16-21.24a12.33,12.33,0,0,1,12.55-12.07l881.32,5.73a12.32,12.32,0,0,1,12.39,12.25l-.16,21.24A12.34,12.34,0,0,1,2549.61,1068.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1346.7,1140.71,1122,1139.25a7.75,7.75,0,0,1-7.8-7.7l.23-30.26a7.76,7.76,0,0,1,7.9-7.6l224.69,1.46a7.75,7.75,0,0,1,7.8,7.71l-.23,30.26A7.76,7.76,0,0,1,1346.7,1140.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1942,1144.58l-530.29-3.45a12.31,12.31,0,0,1-12.39-12.25l.16-21.23a12.31,12.31,0,0,1,12.55-12.07l530.3,3.44a12.32,12.32,0,0,1,12.39,12.25l-.16,21.24A12.34,12.34,0,0,1,1942,1144.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1345.92,1220.74l-224.69-1.46a7.75,7.75,0,0,1-7.8-7.71l.23-30.26a7.75,7.75,0,0,1,7.9-7.59l224.69,1.46a7.75,7.75,0,0,1,7.8,7.71l-.23,30.26A7.76,7.76,0,0,1,1345.92,1220.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2203.48,1226.31,1536.2,1222a12.32,12.32,0,0,1-12.39-12.25l.16-21.24a12.32,12.32,0,0,1,12.56-12.07l667.28,4.34A12.31,12.31,0,0,1,2216.2,1193l-.16,21.24A12.32,12.32,0,0,1,2203.48,1226.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1347.24,1300.9l-224.69-1.46a7.75,7.75,0,0,1-7.79-7.71l.23-30.26a7.75,7.75,0,0,1,7.9-7.59l224.69,1.46a7.75,7.75,0,0,1,7.79,7.71l-.23,30.26A7.75,7.75,0,0,1,1347.24,1300.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2553.77,1308.74l-912.09-5.93a12.3,12.3,0,0,1-12.39-12.25l.16-21.24a12.33,12.33,0,0,1,12.55-12.07l912.1,5.93a12.32,12.32,0,0,1,12.39,12.25l-.16,21.24A12.33,12.33,0,0,1,2553.77,1308.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1341.22,1540l-224.69-1.46a7.75,7.75,0,0,1-7.8-7.7l.23-30.26a7.76,7.76,0,0,1,7.9-7.6l224.69,1.46a7.74,7.74,0,0,1,7.79,7.71l-.22,30.26A7.76,7.76,0,0,1,1341.22,1540Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1936.48,1543.91l-530.29-3.45a12.31,12.31,0,0,1-12.39-12.25L1394,1507a12.31,12.31,0,0,1,12.55-12.07l530.3,3.44a12.32,12.32,0,0,1,12.39,12.25l-.16,21.24A12.34,12.34,0,0,1,1936.48,1543.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1340.44,1620.07l-224.69-1.46a7.75,7.75,0,0,1-7.8-7.71l.23-30.26a7.75,7.75,0,0,1,7.9-7.59l224.69,1.46a7.74,7.74,0,0,1,7.79,7.71l-.22,30.26A7.76,7.76,0,0,1,1340.44,1620.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2197.63,1625.64l-667.28-4.34a12.3,12.3,0,0,1-12.39-12.25l.16-21.23a12.31,12.31,0,0,1,12.55-12.07l667.29,4.33a12.32,12.32,0,0,1,12.39,12.25l-.16,21.24A12.33,12.33,0,0,1,2197.63,1625.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1341.76,1700.23l-224.69-1.46a7.75,7.75,0,0,1-7.79-7.71l.23-30.26a7.75,7.75,0,0,1,7.9-7.59l224.69,1.46a7.75,7.75,0,0,1,7.79,7.71l-.23,30.26A7.75,7.75,0,0,1,1341.76,1700.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2547.92,1708.07l-912.1-5.93a12.32,12.32,0,0,1-12.39-12.25l.16-21.24a12.33,12.33,0,0,1,12.56-12.07l912.09,5.93a12.32,12.32,0,0,1,12.4,12.25l-.17,21.24A12.33,12.33,0,0,1,2547.92,1708.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1343.82,1382.39l-224.69-1.46a7.75,7.75,0,0,1-7.8-7.7l.23-30.26a7.77,7.77,0,0,1,7.9-7.6l224.69,1.46a7.75,7.75,0,0,1,7.8,7.71l-.23,30.26A7.75,7.75,0,0,1,1343.82,1382.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2546,1390.2l-912.09-5.92a12.31,12.31,0,0,1-12.39-12.25l.16-21.24a12.32,12.32,0,0,1,12.55-12.07l912.1,5.93a12.31,12.31,0,0,1,12.39,12.25l-.16,21.23A12.32,12.32,0,0,1,2546,1390.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1345.15,1462.55l-224.69-1.46a7.75,7.75,0,0,1-7.8-7.7l.23-30.26a7.75,7.75,0,0,1,7.9-7.6l224.69,1.46a7.74,7.74,0,0,1,7.79,7.71l-.22,30.26A7.76,7.76,0,0,1,1345.15,1462.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2550.31,1470.38l-912.09-5.93a12.31,12.31,0,0,1-12.39-12.24L1626,1431a12.32,12.32,0,0,1,12.55-12.07l912.1,5.93a12.31,12.31,0,0,1,12.39,12.24l-.16,21.24A12.32,12.32,0,0,1,2550.31,1470.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1007.09,1183.75H241.41c-29.87,0-54.07-10.41-54.07-23.26V676.35c0-13,24.83-23.5,55.09-23.26l768.69,6.24c29.52.24,53.13,10.62,53.05,23.33l-3,477.89C1061.07,1173.38,1036.89,1183.75,1007.09,1183.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1003.78,1747.45H238.1c-29.86,0-54.07-10.41-54.07-23.26V1240.05c0-13,24.84-23.51,55.09-23.26l768.7,6.24c29.52.24,53.13,10.62,53,23.32l-3,477.9C1057.77,1737.07,1033.59,1747.45,1003.78,1747.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2664.07,615.65l.15-44.2A75.2,75.2,0,0,0,2590.84,496L204.55,447.79a81.42,81.42,0,0,0-83.4,81.46v86.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 240.29,
    cy: 536.22,
    r: 39.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 481.86,
    cy: 536.22,
    r: 39.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 359.42,
    cy: 536.22,
    r: 39.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M469.46,2748.05c-3.7,0-6.71-1.86-6.71-4.16V2246.5c0-2.29,3-4.16,6.71-4.16s6.7,1.87,6.7,4.16v497.39C476.16,2746.19,473.16,2748.05,469.46,2748.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M261.33,2748.05c-3.71,0-6.71-1.86-6.71-4.16V2246.5c0-2.29,3-4.16,6.71-4.16s6.7,1.87,6.7,4.16v497.39C268,2746.19,265,2748.05,261.33,2748.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M25.11,2748.21a6.7,6.7,0,1,0,12.33,5.25l217.29-511.11c-4.66-.22-9.32-.73-14-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M236.82,2748.21a6.71,6.71,0,0,0,12.34,5.25L468.29,2238q-7.08-.5-14.21-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M493.35,2253H43.12a8.38,8.38,0,0,1-8.38-8.38h0a8.38,8.38,0,0,1,8.38-8.38H493.35a8.38,8.38,0,0,1,8.38,8.38h0A8.38,8.38,0,0,1,493.35,2253Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 188.43,
    y: 2374.4,
    width: 212.35,
    height: 13.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M344.56,2520.44H132.21a6.7,6.7,0,1,1,0-13.4H344.56a6.7,6.7,0,0,1,0,13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M287.22,2649.75H74.88a6.7,6.7,0,1,1,0-13.4H287.22a6.7,6.7,0,0,1,0,13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2025.35,2600.79a337.83,337.83,0,0,1,4.05,35.27,15.19,15.19,0,0,1-13.69,16c-28.32,2.74-92.79,7.82-134,1.88a6.91,6.91,0,0,1-3.79-11.89c17-15.82,58-46.58,125.44-53.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2039.43,2564.44l-14.32,35.1a11.69,11.69,0,0,1-12,7.26,64.66,64.66,0,0,1-11.7-2.26,15.39,15.39,0,0,1-10.22-19.12l10.81-36.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2284.26,2628.75s-28.68,24-39.85,54.77a13.08,13.08,0,0,0,12.43,17.38h59a13.91,13.91,0,0,0,13.75-16.28C2325.84,2663.37,2315,2628.84,2284.26,2628.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2319.78,2597.52s-5.79,25.64-10.24,42.58a5.42,5.42,0,0,1-7.09,3.7c-8.93-3.2-16.19-4.61-21.48-3.9a4.17,4.17,0,0,1-4.6-4.17l-.56-42.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2167.27,2020.63l-174.42,532.11s33.46,21.91,49.4,21l207.17-427.64s36.25,263.5,18.68,452.67l59.34,4.53s96.49-483.43,23.41-649Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2248.3,2141.51l.21,0a1.67,1.67,0,0,0,1.46-1.88l-6.76-53.73a1.69,1.69,0,0,0-3.36.42l6.77,53.73A1.7,1.7,0,0,0,2248.3,2141.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2134.57,1552.4s141.32,12.55,121.33,113.24c0,0,78.11,147,114.63,320.17a10.18,10.18,0,0,1-8.26,12.1l-235.34,40.3a12.67,12.67,0,0,1-14.4-9.32l-56.23-217.31-21.91,101-69.62-18.14,58.61-296.89S2031.56,1554.26,2134.57,1552.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2055.11,1801.86a1.61,1.61,0,0,0,.37,0,1.76,1.76,0,0,0,1.34-2.09l-19.62-90.07a1.75,1.75,0,0,0-3.42.74l19.61,90.08A1.76,1.76,0,0,0,2055.11,1801.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2069.31,2069.89a33.64,33.64,0,0,1,24.3-3.16l16.37,4.08a5.93,5.93,0,0,0,7.33-5.1l17-150.81c21.18,10.06,51.75,8.86,61.83,8.12l-39,177.8H2020.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1706.71,1742.76l4.13-13.71a27.07,27.07,0,0,1,15.85-17.34l74.6-30s1.13-9.57-15.76-16.07-12.94-25.42-12.94-25.42,23.07,10.53,56.85,27.22c19.32,9.55,30.16,26.4,35.9,39.09l169.05,206.08-19.85,13.64a53,53,0,0,1-76.82-18.85l-91.58-175.61C1800.16,1745.6,1753.63,1748.24,1706.71,1742.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2088.79,1456.26l43.47,121.65s-38.49,30.09-66.58,19.91l-21.9-69.73S2060.51,1442.87,2088.79,1456.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1959.07,1412.57c0,1.88,41.87,118.53,41.87,118.53l66.1-25.32-23.26-116.46S1959.07,1381.19,1959.07,1412.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2032.19,1417.69l17,60.35a8.5,8.5,0,0,1,.33,2.35c0,4.93-1.21,21.86-18.46,19.56-15.65-2.09-30-3.77-39.07.52a8.75,8.75,0,0,0-4.52,10.88c3.81,10.6,12.83,34.32,23.81,53.73a8.72,8.72,0,0,0,11.23,3.6c12.42-5.65,38.26-18.29,56.68-33.33a8.79,8.79,0,0,0,3.1-8.41c-2.9-15.44-11.53-62.39-11.91-75.85-.36-12.62,13.81-22.27,20-25.89a8.64,8.64,0,0,0,4.06-5.44c1.95-8.13,3.62-26.53-19.85-30.58a8.78,8.78,0,0,1-7.12-10.44c2-9.72,1.36-24-17.11-29.3-18.76-5.35-30.57,5.94-36.57,14.61a8.77,8.77,0,0,1-10.87,2.89c-2.21-1-4.89-1-7.76,1.4a8.63,8.63,0,0,1-12.62-1.92c-5.48-8.06-15.42-16.1-32.24-10.65-29.87,9.66-28.44,44.09-17.49,62.81s42.72,6.4,57.77-6c11.44-9.43,28.85-3.78,36.55-.54A8.72,8.72,0,0,1,2032.19,1417.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2076.41,1473.13s-17.68-33.43-6-43.93,31.49-8.78,30.95,17.36C2100.71,1479.08,2076.41,1473.13,2076.41,1473.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2182.38,1925.29a169.12,169.12,0,0,0,17.27-.82l1.25-.14,51.46-239.91a1.75,1.75,0,1,0-3.43-.73L2198,1921.11c-7.66.67-48.55,3.38-70.14-11.91l44.58-208.43-9.31-17.54a1.75,1.75,0,1,0-3.09,1.64l8.71,16.41L2124,1910.67l.89.68C2140.47,1923.07,2165.59,1925.29,2182.38,1925.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2115.79,2721.44a9.42,9.42,0,0,0,4-.9c5.14-2.41,7.52-8.92,5.3-14.53l-212.52-539.25c-2.21-5.61-8.17-8.2-13.32-5.79s-7.51,8.92-5.3,14.53l212.53,539.25A10.13,10.13,0,0,0,2115.79,2721.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1876.37,2721.44a10.12,10.12,0,0,0,9.31-6.69l212.53-539.25c2.21-5.61-.16-12.11-5.3-14.53s-11.1.18-13.32,5.79L1867.07,2706c-2.22,5.61.16,12.12,5.3,14.53A9.42,9.42,0,0,0,1876.37,2721.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1211.16,2721.44a9.38,9.38,0,0,0,4-.9c5.15-2.41,7.52-8.92,5.31-14.53l-212.53-539.25c-2.21-5.61-8.16-8.2-13.31-5.79s-7.52,8.92-5.3,14.53l212.52,539.25A10.14,10.14,0,0,0,1211.16,2721.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M971.74,2721.44a10.14,10.14,0,0,0,9.31-6.69l212.53-539.25c2.21-5.61-.17-12.11-5.31-14.53s-11.1.18-13.31,5.79L962.43,2706c-2.21,5.61.17,12.12,5.31,14.53A9.39,9.39,0,0,0,971.74,2721.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1328.55,
    y: 2358.06,
    width: 25.13,
    height: 271.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1231.07,2635h220.08v-7.29a9.06,9.06,0,0,0-9.06-9.06H1240.14a9.07,9.07,0,0,0-9.07,9.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1198.41,
    y: 2297.18,
    width: 276.71,
    height: 78.48,
    rx: 27.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1526.62,2176.62s37.34,5.76,79.32,33.68a20.77,20.77,0,0,1,9.23,19.9c-5,39.61-25.69,167.84-93.85,293.08a31.43,31.43,0,0,0-3,21.63l11.84,54.83,22,20.48h-56.56l-37.66-101.4,16.1-5.06a30.33,30.33,0,0,0,21.28-28.38l1.89-108.77c-1.61-48.46,29.87-81.9,29.87-81.9l-90.33-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1574.17,2630.11c5.15,6.71-55.44,15.56-86.06.89,0,0-42.43-73.46-42.43-111.28,0,0,3.37-7.71,28.28-6,0,0,14.25,87,29.3,96.72s42.09,1,42.09,1S1566.57,2620.22,1574.17,2630.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1448.1,2296.31c.48-.83,97.25-11.58,97.25-11.58s-3.17,29.28,6.73,69.57,152,214.9,152,214.9l-14.9,47c46.07,16,91.37,18.52,136,8.14l-92.33-55.13s-86.4-293-139.33-345.23l-97-33.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1231.07,2125.84s-55.75,82.51-60.33,120.14,15.27,52.93,73.78,55.46,214.67,2.48,214.67,2.48l133.29-113.34s-97.13-34.49-122.39-44.24S1231.07,2125.84,1231.07,2125.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1694.79,2600.36s-16,15.46-5.2,32.66c0,0,127.05,22.4,161.55,12.24,0,0-7.16-16.27-46-34.78l2.87,2.19a4.61,4.61,0,0,1-3.07,8.28C1779.34,2619.5,1726.37,2614.83,1694.79,2600.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1343.75,1660c-8.43,2.63-38.8,13.53-34.87,33.06a3.58,3.58,0,0,1-4.48,4.1c-13.08-3.52-42-8-59.91,14.49-15.82,19.82-4,38.53,5.64,48.8a3.59,3.59,0,0,1-3,6.08c-24.06-3-76.33-3.77-84.88,45.2-8,45.66,23.81,58.54,42.66,62.17a3.58,3.58,0,0,1,1.19,6.55c-9.4,6-20.3,18.29-15.9,42.62,6.9,38.13,81.66,35,90.4,34.51a3.53,3.53,0,0,0,1.56-.46l119.75-68.3a3.58,3.58,0,0,0,1.76-2.51l24.18-139.62a3.61,3.61,0,0,0-1-3.11l-79.5-82.63A3.58,3.58,0,0,0,1343.75,1660Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1381.85,2114.86s64.93-61.82,96.89-102.77a86.86,86.86,0,0,0,14.71-78.19c-14.59-49.16-40.52-100.07-42.88-108-3.63-12.15-76.43-11.64-76.43-11.64s-143.25,93-199.54,250.47l63.21,19.67s37.41-62.75,74.36-102.64c0,0-64,84.48-66.2,119.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1459.37,1758c-.76,2.52-19.76,65.51-21.25,66.82s-41.67,3.47-60.58-9.46l32.09-67.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1428.16,1625.71s34.3,14.49,57.62,64.06,5.91,72.45-16,75.59-54.6,2.67-89.2-29.36S1383.57,1608.54,1428.16,1625.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1403.87,1709.54s-25.88-72.52,38.42-73.38l15.13,10.58s23.59-40.21-15.13-59.4-84-3.34-100.52,48.82-19.29,87.09,8.12,112,38.71-3.34,38.71-3.34-14.92-23.35-8.85-35.84,20.1,2.59,20.1,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1406.59,1719.27s-12.72-36.91-30.54-22.48c-23.15,18.75,10.55,37,26.57,40.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1514.13,2119.45l-47.71-46-66,27.88s-65.68,10.18-103.28,0l-37.59-10.18-85-26.44-13.34,37.7a22.7,22.7,0,0,0,8.29,26.09c7.35,5.22,16,11,21.46,13.37,11.19,4.89,275.79-3.39,275.79-3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1333.6,2141.13h.64l276.71-.3a12.39,12.39,0,1,0,0-24.77l-276.72.3a12.39,12.39,0,0,0-.61,24.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1859.71,1889.89H1629.26a43.92,43.92,0,0,0-39.73,25.19L1483,2141h286.38a26.69,26.69,0,0,0,24.83-16.88l82.61-209A18.4,18.4,0,0,0,1859.71,1889.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1697.35,2005.72c-5,15.51-1.3,30.58,8.24,33.65s21.34-7,26.33-22.53,1.3-30.58-8.24-33.65S1702.35,1990.2,1697.35,2005.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1888.59,2132.29h272.34v-28.1H1888.59C1894.42,2104.19,1894.42,2132.29,1888.59,2132.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M2157.62,2132.29a3.32,3.32,0,0,0,3.31-3.31V2107.5a3.32,3.32,0,0,0-3.31-3.31h-274a3.18,3.18,0,1,1,0-6.36h292.92a11.76,11.76,0,0,1,11.76,11.76v18a11.09,11.09,0,0,1-11.09,11.09H1883.6a3.18,3.18,0,1,1,0-6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M946.86,2151.24a9.71,9.71,0,0,1,2.59-8.85,13.17,13.17,0,0,1,9.51-3.89H2205.29a14.8,14.8,0,0,1,11.95,5.68,10.94,10.94,0,0,1,.93,11.81l-13.51,25.38c-3.09,5.82-9.79,9.54-17.16,9.54h-1220c-6.86,0-12.75-4.23-14-10.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M633.57,975.69s-74.23,202.37-200.72,265.62c0,0,42.1,68.69,64.07,72.86,0,0,135.13-173,148.9-314.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M640.7,1012.52c1.13,3.61-12,9.09-19.71-5.64-.27-7.06-4.56-37.29-.34-43,22.46-30.62,46.18-32.61,46.18-32.61,4.42,8,9.81,14.73,12.33,24.39a29.52,29.52,0,0,1-2.95,21.78c-3.71,6.68-8.77,15.37-13.55,22.17C653.61,1012.43,640.7,1012.52,640.7,1012.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M409.19,1306l513.49-7.37a24.66,24.66,0,0,0,24.3-25l-7.44-518.8a24.66,24.66,0,0,0-25-24.3L401,737.84a24.65,24.65,0,0,0-24.3,25l7.44,518.8A24.67,24.67,0,0,0,409.19,1306Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M432.22,1158.64l104.8-151a6.13,6.13,0,0,1,4.92-2.53,6.21,6.21,0,0,1,5,2.34l65.71,86.14L715.49,947.85a6.46,6.46,0,0,1,5.13-2.61,6.39,6.39,0,0,1,5.24,2.34l164.09,210a6.22,6.22,0,0,1,.44,6.47c-1.07,1.82-3.21,3.67-5.58,3.67L668.4,1168l-107.22.12-123.86.15c-2.15,0-4.16-1.76-5.22-3.49A6.17,6.17,0,0,1,432.22,1158.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M505.86,914c.6,25.38,22.15,45.45,48.28,44.82s47.19-22,46.58-47.62-22.51-45.72-48.78-44.81C525.83,867.24,505.26,888.56,505.86,914Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M362,1070.13s-26.1,12.69-30.9,27.27c-3.85,11.7-32.7,13.21-35.55,36.22a26.41,26.41,0,0,1-22.1,23.21c-29.47,4.51-74.88,19.82-82.15,71-5.54,39.06,14.37,53.86,35.26,59,15.35,3.76,25.54,18.69,22.44,34.18-3,14.87,1.46,32,27.21,45.63,57.69,30.44,115.3-72.12,115.3-72.12l11.81-179.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M124.87,2193l-3.73,30.69A12.68,12.68,0,0,1,110,2234.79c-9.84,1.13-25.63,2.28-41.08.65a10.87,10.87,0,0,1-9.12-14.09c3.77-11.84,10.66-29.63,20.59-40.09h34.05A10.49,10.49,0,0,1,124.87,2193Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M391.52,1833.49l5.75,33.8S378,2062.21,374.6,2140.18a61.12,61.12,0,0,0,9,34.72l33.46,54.34-85-50.18-1.7-10.38,13.92-19.14-18.23-218.36a67,67,0,0,1,7.62-37l17.59-33.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M422.71,2237.11H395.57a16.33,16.33,0,0,1-13-6.36c-8.46-11-26-32.44-34.37-33-11.28-.75-9.84,39.36-9.84,39.36h-6.32l-8-49.84a29.52,29.52,0,0,1,15.49-30.84h0s2.58,19.07,16.56,27.51S413,2222.59,413,2222.59a38.84,38.84,0,0,1,11,.29C432.6,2224.43,431.41,2237.11,422.71,2237.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M275.05,1849.54s-112.74,213.85-130.66,262.67-24.2,89.56-24.44,93.41c-.37,6-7.87,11.81-28.53,11.81-10.66,0-15.89-4.27-18.44-8.41a12,12,0,0,1-.46-11.67c6.52-13.2,27.22-55.37,34.88-74.5,9.15-22.84,28.84-126.34,39.63-162.33s23-75,70-111C217,1849.54,249.31,1817.94,275.05,1849.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M346.26,1499.15c29.08-123.22-44.59-192.92-44.59-192.92,46.49-44.62,131.18-64.92,131.18-64.92s80.81,59.08,71.23,105.33c-5.62,27.1-56.81,162.35-56.81,162.35S399.94,1531.39,346.26,1499.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M281.79,1560.16c11.83-35.66,64.47-61,64.47-61,53.68,32.24,101,9.84,101,9.84s10.62,40.57,3.29,78.28-53.29,280-53.29,280c-72.42,14.68-183.81-14.76-183.81-14.76C259.59,1770.63,270,1595.81,281.79,1560.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M380,1159.88l-23.65,106.2c-2.26,9.35,6.27,7.82,15.72,6,15.49-2.92,35.45-8.94,42.13-21a11.33,11.33,0,0,0,1.21-4l10.15-73.64a13.22,13.22,0,0,0-7.74-13.9l-19.6-8.69A13.23,13.23,0,0,0,380,1159.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M407.76,1058.76s28,11.83,47,52.29,4.82,59.14-13,61.71-44.57,2.17-72.82-24S371.36,1044.75,407.76,1058.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M387.93,1127.19s-21.12-59.19,31.36-59.89l12.35,8.63s19.26-32.82-12.35-48.49-68.6-2.73-82.05,39.86-15.75,71.08,6.63,91.46,31.6-2.73,31.6-2.73-12.19-19.06-7.22-29.25,16.4,2.11,16.4,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M382.05,1133.79s-10.69-30.5-24.93-18.35,11.58,28.17,21.69,33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M288.6,1339s216.27,264.07,377.84-36.61c0,0,3.1-7.69,1.16-18.78-1-5.61,2.73-25.48,4.77-35.64a5.59,5.59,0,0,0-5-6.66h0a7.65,7.65,0,0,0-6.75,2.89l-29.52,37.58a15.75,15.75,0,0,0,8.36,18.7h0a7.78,7.78,0,0,1,2.88,11.74c-122.88,161.08-328.4-15.67-332.16-13.6C296.85,1306,281.43,1314.17,288.6,1339Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1588.88,
    cy: 1328.24,
    r: 185.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1528.72,1374.51l-78.17-39.78v-12.82l78.17-45.26v21.81l-54.08,28.88,54.08,25.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1611.87,1259l-44.46,134.36-22.33-.23,44.11-133.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1628.4,1353.09l57.13-26.07-57.13-29.23V1275.6l83.31,45.66v13.41l-83.31,40.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-43",
    cx: 1922.5,
    cy: 1040.69,
    r: 185.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1862.52,968v156.12c0,10,8.49,16.28,15.82,11.68l130.74-82.07c8.15-5.12,8.15-19.62,0-24.24l-130.74-74.12C1871,951.2,1862.52,958,1862.52,968Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 2327.66,
    cy: 1235.66,
    r: 185.32,
    transform: "translate(-191.99 2007.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 2218.83,
    y: 1230.17,
    width: 45.5,
    height: 83.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 2292.58,
    y: 1182.16,
    width: 45.5,
    height: 131.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 2367.89,
    y: 1140,
    width: 45.5,
    height: 173.32
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceAugmentation3);
export default __webpack_public_path__ + "static/media/resource_augmentation_3.39834f1f3241c24a1a7520440f4e01ec.svg";
export { ForwardRef as ReactComponent };